enum AssetTypeEnum {
  Image = 1,
  Video
}

export default AssetTypeEnum;
